const frontUrl = 'https://dev.cvcraft.fr';
const backUrl = 'https://api-dev.cvcraft.fr';

export const environment = {
  production: false,
  linkedinClientId: '77whtzyu5scpyg',
  linkedinRedirectUri: `${frontUrl}/auth/callback/linkedin`,
  googleClientId: '890959064943-h38bicii43lb06oambhfhdi0fnn3pmlu.apps.googleusercontent.com',
  googleRedirectUri: `${frontUrl}/auth/callback/google`,
  apiUrl:  `${backUrl}/api`,
  signalRUrl: `${backUrl}/hubs`,
};
